export default __webpack_public_path__ + "static/media/application-payment-icon.70665cbd.svg";